export default __webpack_public_path__ + "static/media/549.5633fdf0.png";